import { ISorter, ISorterConfig, ISorterExpression, SorterConfig } from "pbc.types";

export interface IRolleSorter extends ISorter {
  id?: ISorterExpression;
  name?: ISorterExpression;
  beschreibung?: ISorterExpression;
  finanzen?: ISorterExpression;
}

export const RolleSorterConfig: ISorterConfig = [
  SorterConfig('id', 'Id'),
  SorterConfig('name', 'Name'),
  SorterConfig('beschreibung', 'Beschreibung'),
  SorterConfig('finanzen', 'Finanzen')
];
